<template>
  <div id="TreeView">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{$t(title)}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-sheet class="pa-3 primary lighten-2">
          <v-text-field
            v-model="search"
            :label="$t('Поиск по названию')"
            dark
            flat
            solo-inverted
            hide-details
            clearable
            clear-icon="mdi-close-circle-outline"
          ></v-text-field>
          <v-checkbox
            v-model="caseSensitive"
            dark
            hide-details
            :label="$t('Поиск с учётом регистра')"
          ></v-checkbox>
        </v-sheet>
        <v-card-text>
          <v-treeview
            :items="items"
            item-key="id"
            :search="search"
            :filter="filter"
            :active.sync="active"
            activatable
            transition
            open-on-click
            active-class="primary--text"
          >
            <v-progress-circular v-if="itemsLoading" indeterminate color="primary"></v-progress-circular>

            <template v-slot:prepend="{ name }"></template>
          </v-treeview>
        </v-card-text>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
    name: 'TreeView',

    data: () => ({ active: [], search: null, caseSensitive: false }),

    props: {
        title: {
            type: String
        },
        items: {
            type: Array
        },
        itemsLoading: {
            type: Boolean
        }
    },
    watch: {
        active: 'onItemSelect'
    },
    computed: {
        filter() {
            return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined;
        }
    },
    methods: {
        async onItemSelect() {
            try {
                if (this.active[0]) {
                    this.$emit('itemSelect', { id: this.active[0] });
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>